import React, { Component } from 'react'
import { Link } from 'gatsby'
import { Link as LinkScroll } from 'react-scroll'
import { slide as Menu } from 'react-burger-menu'

import './navigationMobile.css'

export default class NavigationMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
    }
  }

  handleStateChange(state) {
    if (state.isOpen) {
      this.setState({ open: state.isOpen })
    }
  }

  closeMenu() {
    this.setState({ open: false })
  }

  renderNavigation() {
    return this.props.items.map(item => {
      if (item.url) {
        return (
          <Link to={item.to} key={item.label} activeClassName={'active'}>
            {item.label}
          </Link>
        )
      }

      return (
        <LinkScroll
          to={item.to}
          key={item.label}
          activeClass={'active'}
          spy={true}
          smooth={true}
          offset={50}
          duration={500}
          onClick={this.closeMenu.bind(this)}
        >
          {item.label}
        </LinkScroll>
      )
    })
  }

  render() {
    return (
      <Menu
        isOpen={this.state.open}
        onStateChange={state => this.handleStateChange(state)}
      >
        {this.renderNavigation()}
      </Menu>
    )
  }
}
